import { combineReducers } from 'redux'
import settings from './settings/reducer'
import menu from './menu/reducer'
import authUser from './auth/reducer'
import card from './card/reducer'
import text from './text/reducer'

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  card,
  text
})

export default reducers
